import { brandText, text } from '@guardian/source-foundations';

export const userFeedbackThemeDefault = {
	userFeedback: {
		textSuccess: text.success,
		textError: text.error,
	},
};

export const userFeedbackThemeBrand = {
	userFeedback: {
		textSuccess: brandText.success,
		textError: brandText.error,
	},
};
